import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { navActionCreators } from '../../stores/lis-nav-store';
import { statActionCreators } from '../../stores/lis-statistics-store';
import { sessionActionCreators } from '../../stores/lis-session-store';


class CommitteeStatDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            stats: [],
            sessionData: '',
            totals: ''
        };

        this.setupPage = this.setupPage.bind(this);
    }

    setupPage(sessionCode) {
        this.setState({
            isLoading: true
        });
        this.props.actions.getSessionByCode(sessionCode).then(() => {
            this.setState({
                sessionData: this.props.session.selectedSession
            }, () => {
                this.props.actions.getCommitteeStats('?sessionId=' + this.state.sessionData.SessionID + '&chambercode=' + this.props.match.params.chambercode)
                    .then(() => {
                        let committeeStats = [...this.props.stats.committeeStats];
                        let totals = {
                            ContinuedFromTotal: 0,
                            HReferredTotal: 0,
                            SReferredTotal: 0,
                            HInCommitteeTotal: 0,
                            SInCommitteeTotal: 0,
                            HInSubCommitteeTotal: 0,
                            SInSubCommitteeTotal: 0,
                            HReportedTotal: 0,
                            SReportedTotal: 0,
                            HIncorporatedTotal: 0,
                            SIncorporatedTotal: 0,
                            HFailedTotal: 0,
                            SFailedTotal: 0,
                            ContinuedToTotal: 0
                        }
                        committeeStats.sort((a, b) => a.CommitteeName.localeCompare(b.CommitteeName))
                        committeeStats.forEach(stat => {
                            totals.ContinuedFromTotal += (stat.HContinuedFrom + stat.SContinuedFrom) || 0;
                            totals.HReferredTotal += stat.HReferred || 0;
                            totals.SReferredTotal += stat.SReferred || 0;
                            totals.HInCommitteeTotal += stat.HInCommittee || 0;
                            totals.SInCommitteeTotal += stat.SInCommittee || 0;
                            totals.HInSubCommitteeTotal += stat.HInSubCommittee || 0;
                            totals.SInSubCommitteeTotal += stat.SInSubCommittee || 0;
                            totals.HReportedTotal += stat.HReported || 0;
                            totals.SReportedTotal += stat.SReported || 0;
                            totals.HIncorporatedTotal += stat.HIncorporated || 0;
                            totals.SIncorporatedTotal += stat.SIncorporated || 0;
                            totals.HFailedTotal += stat.HFailed || 0;
                            totals.SFailedTotal += stat.SFailed || 0;
                            totals.ContinuedToTotal += (stat.HContinued + stat.SContinued) || 0;
                        });
                        this.setState({
                            stats: committeeStats,
                            totals: totals,
                            isLoading: false
                        });
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        this.setState({
                            isLoading: false,
                            message: this.props.stats.committeeStatsError
                        })
                    });
            });
        });
    }

    componentDidMount() {
        if (this.props.match.params.sessioncode) {
            //Update the session selector component, which will run componentDidUpdate and call setupPage on its own
            if (this.props.nav.session !== this.props.match.params.sessioncode) {
                this.props.actions.changeSession(this.props.match.params.sessioncode)
            } else {
                this.setupPage(this.props.match.params.sessioncode);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.chambercode !== prevProps.match.params.chambercode) {
            this.setupPage(this.props.match.params.sessioncode);
        }
        // Setup the page if the global selected session changes. Change the URL to reflect the session change
        if (prevProps.nav.session !== this.props.nav.session) {
            this.props.history.push('/session-details/' + this.props.nav.session + '/statistics/committee/' + this.props.match.params.chambercode)
            this.setupPage(this.props.nav.session);
        } else if (this.props.nav.session !== this.props.match.params.sessioncode) {
            // If the url changes then update the global selected session with whatever the url is
            if (this.props.match.params.sessioncode) {
                this.props.actions.changeSession(this.props.match.params.sessioncode);
            }
        }
    }

    render() {
        if (this.state.isLoading) {
            return (<div aria-label="Loading" className="center-spinner spinner"></div>)
        }
        if (this.state.message) {
            return (<div className="center">{this.state.message}</div>)
        }
        return (
            <div>
                <br />
                <div className="full">
                    <table className="statistics-table">
                        <caption>
                            <h1>
                                {this.state.sessionData && <span className="statistics-header">{this.state.sessionData.SessionYear} {this.state.sessionData.DisplayName}</span>}
                                <span className="statistics-header">{this.props.match.params.chambercode.toLowerCase() === "s" ? " Senate" : " House"} Committee Statistics</span>
                            </h1>
                            {this.props.match.params.chambercode.toLowerCase() === "s" &&
                                <Link to={`/session-details/${this.props.match.params.sessioncode}/statistics/committee/h`}>House Committee Statistics</Link>
                            }
                            {this.props.match.params.chambercode.toLowerCase() === "h" &&
                                <Link to={`/session-details/${this.props.match.params.sessioncode}/statistics/committee/s`}>Senate Committee Statistics</Link>
                            }
                            <span> | </span>
                            <Link to={`/session-details/${this.props.match.params.sessioncode}/statistics/status`}>Session Statistics</Link>
                        </caption>
                        <tbody>
                            <tr>
                                <th><span className="screen-reader-only">Committee Name</span></th>
                                {this.state.totals.ContinuedFromTotal > 0 && <th style={{ padding: "0 5px", whiteSpace: "normal" }}>Continued From {this.state.sessionData.SessionYear - 1}</th>}
                                <th>
                                    <div className="stat-header-name">
                                        Referred
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                <th>
                                    <div className="stat-header-name">
                                        In Committee
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                <th>
                                    <div className="stat-header-name">
                                        In Subcommittee
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                <th>
                                    <div className="stat-header-name">
                                        Reported
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                <th>
                                    <div className="stat-header-name">
                                        Incorporated
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                <th>
                                    <div className="stat-header-name">
                                        Failed
                                    </div>
                                    <div className="stat-header-chambers">
                                        <div>H</div>
                                        <div>S</div>
                                    </div>
                                </th>
                                {this.state.totals.ContinuedToTotal > 0 && <th style={{ padding: "0 5px", whiteSpace: "normal" }}>Continued To {this.state.sessionData.SessionYear + 1}</th>}
                            </tr>
                            {this.state.stats.map((stat, statIndex) =>
                                <tr key={statIndex}>
                                    <td className="homepage-links"><Link to={`/session-details/${this.props.match.params.sessioncode}/committee-information/${stat.CommitteeNumber}/committee-details`}>{stat.CommitteeName}</Link></td>
                                    {this.state.totals.ContinuedFromTotal > 0 && <td>{stat.HContinuedFrom + stat.SContinuedFrom}</td>}
                                    {/*  More nested div garbage coming */}
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HReferred}</div>
                                            <div>{stat.SReferred}</div>
                                        </div>
                                    </td>
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HInCommittee}</div>
                                            <div>{stat.SInCommittee}</div>
                                        </div>
                                    </td>
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HInSubCommittee}</div>
                                            <div>{stat.SInSubCommittee}</div>
                                        </div>
                                    </td>
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HReported}</div>
                                            <div>{stat.SReported}</div>
                                        </div>
                                    </td>
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HIncorporated}</div>
                                            <div>{stat.SIncorporated}</div>
                                        </div>
                                    </td>
                                    <td className="stat-cell">
                                        <div className="stat-cell-values">
                                            <div>{stat.HFailed}</div>
                                            <div>{stat.SFailed}</div>
                                        </div>
                                    </td>
                                    {this.state.totals.ContinuedToTotal > 0 && <td>{stat.SContinued + stat.HContinued}</td>}
                                </tr>
                            )}
                            <tr>
                                <td style={{ fontSize: "14px", padding: "0 10px" }}>Total for all {this.props.match.params.chambercode.toLowerCase() === "s" && "Senate"}{this.props.match.params.chambercode.toLowerCase() === "h" && "House"} Committees</td>
                                {this.state.totals.ContinuedFromTotal > 0 && <td>{this.state.totals.ContinuedFromTotal}</td>}
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HReferredTotal}</div>
                                        <div>{this.state.totals.SReferredTotal}</div>
                                    </div>
                                </td>
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HInCommitteeTotal}</div>
                                        <div>{this.state.totals.SInCommitteeTotal}</div>
                                    </div>
                                </td>
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HInSubCommitteeTotal}</div>
                                        <div>{this.state.totals.SInSubCommitteeTotal}</div>
                                    </div>
                                </td>
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HReportedTotal}</div>
                                        <div>{this.state.totals.SReportedTotal}</div>
                                    </div>
                                </td>
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HIncorporatedTotal}</div>
                                        <div>{this.state.totals.SIncorporatedTotal}</div>
                                    </div>
                                </td>
                                <td className="stat-cell">
                                    <div className="stat-cell-values">
                                        <div>{this.state.totals.HFailedTotal}</div>
                                        <div>{this.state.totals.SFailedTotal}</div>
                                    </div>
                                </td>
                                {this.state.totals.ContinuedToTotal > 0 && <td>{this.state.totals.ContinuedToTotal}</td>}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        const { stats, nav, session } = state;
        return {
            stats,
            nav,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, statActionCreators, navActionCreators, sessionActionCreators), dispatch)
        }
    }
)(CommitteeStatDetails)
